module.exports = __webpack_public_path__ + "img/stul.e0d4b926.svg";